import script from "./ManageBrandBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBrandBox.vue?vue&type=script&setup=true&lang=js"

import "./ManageBrandBox.vue?vue&type=style&index=0&id=5e5d6b7e&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5d6b7e"]])

export default __exports__